<template>
      <transition>
        <div v-if="settings.work.queue" class="column-left">

          <draggable v-model="plannedList" group="planned-cards" @start="drag=true" @end="drag=false" @change="checkMove">
            <transition-group name="list" appear>
              <div v-for="(card, index) in plannedList" :key="card.id">
              <a v-bind:href="card.link" target="_blank">
                <div class="card" v-bind:class="[ {neutral: (defaultZero(card.planned_days) < oldThreshold && defaultZero(card.planned_days) > newThreshold)}, {new: (defaultZero(card.planned_days) <= newThreshold)}, {old: (defaultZero(card.planned_days) >= oldThreshold)} ]">
                  <h5>{{ card.contract }}<span class="timestamp">{{ formatTimestamp(card.planned_first_seen, 'month') }}</span></h5>
                  <span>{{ card.name }}</span>
                  <a v-on:click.prevent>
                    <div class="priority">
                      <div v-if="index > 0" v-on:click="toTop(card.id)">
                        <img class="arrows" src="../../assets/arrow_up-24px.svg">
                      </div>
                      <div v-else>
                        <img class="arrows-inactive" src="../../assets/arrow_up-24px.svg">
                      </div>
                      <div v-if="index < (plannedList.length - 1)" v-on:click="toBottom(card.id)">
                        <img class="arrows" src="../../assets/arrow_down-24px.svg">
                      </div>
                      <div v-else>
                        <img class="arrows-inactive" src="../../assets/arrow_down-24px.svg">
                      </div>
                    </div>
                  </a>
                  <div v-if="settings.global.dots" class="days">
                    <div v-for="(n,i) in dots(defaultZero(card.planned_days))" v-bind:key=i>
                      <div v-html=n></div>
                    </div>
                  </div>
                  <div v-else class="days">
                    {{ defaultZero(card.planned_days) }}
                  </div>
                </div>
              </a>
              </div>
            </transition-group>
          </draggable>

        </div>
      </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'PriorityList',
  props: [
    'planned',
    'oldThreshold',
    'newThreshold'
  ],
  components: {
    draggable
  },
  computed: {
    ...mapGetters([
      'id_token',
      'accounts',
      'settings'
    ]),
    plannedList: {
      get: function () {
        return this.planned
      },
      set: function () {
        return this.planned
      }
    }
  },
  methods: {
    checkMove: function (evt) {
      const newIndex = evt.moved.newIndex
      const oldIndex = evt.moved.oldIndex
      const card = evt.moved.element

      var cardAbove = null
      var cardBelow = null
      var newPriority = null

      if (newIndex === 0) {
        cardBelow = this.planned[newIndex + 1]
        newPriority = cardBelow.priority - 1
      } else if (newIndex === this.planned.length - 1) {
        cardAbove = this.planned[newIndex - 1]
        newPriority = cardAbove.priority + 1
      } else {
        cardAbove = this.planned[newIndex - 1]
        cardBelow = this.planned[newIndex + 1]
        if (cardAbove.priority === cardBelow.priority) {
          newPriority = newIndex > oldIndex ? cardAbove.priority + 1 : cardBelow.priority - 1
        } else {
          newPriority = Math.random() * (cardAbove.priority - cardBelow.priority) + cardBelow.priority
        }
      }

      this.$emit('update', {cardId: card.id, newPriority: newPriority})
      return true
    },
    formatTimestamp: function (timestamp, period) {
      let date = new Date(timestamp * 1000)
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Octr', 'Nov', 'Dec']
      let weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      let day = date.getDate()
      let weekday = weekdays[date.getDay()]
      let month = months[date.getMonth()]
      let hours = date.getHours()
      let minutes = '0' + date.getMinutes()
      if (period === 'week') {
        return weekday + ' ' + hours + ':' + minutes.substr(-2)
      } else {
        return month + ' ' + day + ', ' + hours + ':' + minutes.substr(-2)
      }
    },
    defaultZero: function (value) {
      if (value) {
        return value
      } else {
        return 0
      }
    },
    dots: function (days) {
      let output = []
      if (days >= 40) {
        output.push(...Array(1).fill('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="#f070a1"/><title>' + days + '</title></svg>'))
      } else if (days >= 5) {
        let dots = Math.floor(days / 5)
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#f070a1"><title>' + days + '</title></circle></svg>'))
      } else {
        let dots = days
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#77a6f7"><title>' + days + '</title></circle></svg>'))
      }
      return output
    },
    toBottom: function (cardId) {
      var newPriority = this.planned[this.planned.length - 1].priority + 1
      // this.priority(cardId, newPriority)
      this.$emit('update', {cardId: cardId, newPriority: newPriority})
    },
    toTop: function (cardId) {
      var newPriority = this.planned[0].priority - 1
      // this.priority(cardId, newPriority)
      this.$emit('update', {cardId: cardId, newPriority: newPriority})
    }
  }
}
</script>

<style scoped src='../../assets/stylesheet/Work.css'></style>



// WEBPACK FOOTER //
// src/components/Work/PriorityList.vue